import React from "react";
import { BellOff } from "lucide-react";
import useNotificationStore from "../../store/useNotificationStore";
import UserAuthStore from "../../store/userStore";
import NotificationItem from "./NotificationItem";
import { markAllNotificationsRead, deleteNotifications } from "../../api/notifications";

const NotificationDrawer = ({ onClose }) => {
  const notifications = useNotificationStore((state) => state.notifications);
  const markAllRead = useNotificationStore((state) => state.markAllRead);
  const clearAll = useNotificationStore((state) => state.clearAll);
  const user = UserAuthStore((state) => state.user);
  const orgId = UserAuthStore((state) => state.orgId);

  const handleMarkAllRead = () => {
    markAllRead();
    if (user?.uid && orgId) {
      markAllNotificationsRead(orgId, user.uid).catch(() => {});
    }
  };

  const handleClearAll = () => {
    clearAll();
    if (user?.uid && orgId) {
      deleteNotifications(orgId, user.uid).catch(() => {});
    }
  };

  const unreadCount = notifications.filter((n) => !n.read).length;

  return (
    <div className="flex flex-col overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 border-b border-edge-gray-200 dark:border-edge-muted-control shrink-0">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-ink-ink dark:text-ink-white">
                Notifications
              </span>
              {unreadCount > 0 && (
                <span className="text-xs font-medium bg-fill-primary text-ink-on-primary rounded-full px-1.5 py-0.5 leading-none">
                  {unreadCount}
                </span>
              )}
            </div>
            <div className="flex items-center gap-3">
              {unreadCount > 0 && (
                <button
                  onClick={handleMarkAllRead}
                  className="text-xs text-ink-primary hover:underline"
                >
                  Mark all read
                </button>
              )}
              {notifications.length > 0 && (
                <button
                  onClick={handleClearAll}
                  className="text-xs text-ink-control-border hover:text-ink-ink dark:hover:text-ink-white transition-colors"
                >
                  Clear all
                </button>
              )}
            </div>
          </div>

          {/* List */}
          <div className="overflow-y-auto max-h-[420px] divide-y divide-edge-gray-100 dark:divide-edge-canvas-hover">
            {notifications.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12 gap-3 text-ink-control-border">
                <BellOff size={28} className="opacity-40" />
                <p className="text-sm">No notifications yet</p>
              </div>
            ) : (
              notifications.map((notification) => (
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                  onClose={onClose}
                />
              ))
            )}
          </div>
    </div>
  );
};

export default NotificationDrawer;
